import api from './api';

export interface ConfigTemplate {
  id: string;
  name: string;
  description?: string;
  edge_model: string;
  tenant_id?: string;
  is_default: boolean;
  is_system: boolean;
  config: any;
}

const configTemplateService = {
  /**
   * List configuration templates
   */
  list: async (params?: { tenantId?: string; edgeModel?: string }) => {
    const response = await api.get('/config-templates', { params });
    return response.data as ConfigTemplate[];
  },

  /**
   * Get template by ID
   */
  getById: async (id: string) => {
    const response = await api.get(`/config-templates/${id}`);
    return response.data as ConfigTemplate;
  },

  /**
   * Create template
   */
  create: async (data: Partial<ConfigTemplate>) => {
    const response = await api.post('/config-templates', data);
    return response.data as ConfigTemplate;
  },

  /**
   * Update template
   */
  update: async (id: string, data: Partial<ConfigTemplate>) => {
    const response = await api.put(`/config-templates/${id}`, data);
    return response.data as ConfigTemplate;
  },

  /**
   * Delete template
   */
  delete: async (id: string) => {
    await api.delete(`/config-templates/${id}`);
  },

  /**
   * Duplicate template
   */
  duplicate: async (id: string, newName: string) => {
    const response = await api.post(`/config-templates/${id}/duplicate`, { name: newName });
    return response.data as ConfigTemplate;
  },
};

export default configTemplateService;

